import { render } from "./Thumbnailcreator.vue?vue&type=template&id=5629414f"
import script from "./Thumbnailcreator.vue?vue&type=script&lang=js"
export * from "./Thumbnailcreator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__